<template>
  <v-sheet class="py-10 ma-auto">
    <SubTitle :title-name="sectionName" />
    <v-row class="listitem flex-wrap justify-center" lines="three" style="width: 100%;max-width: 1200px;">
      <v-col v-for="(item, i) in items" :key="i" cols="12" md="6" lg="4">
        <v-row class="d-flex align-center ma-1">
          <v-col class="itemtitle text-black" cols="12" md="4">{{ item.title }}</v-col>
          <v-col class="text-white text-body-1 wrap-text">
            <div v-html="item.text.replace(/<br>/g, '<br />')"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <LimitedVer />
    <campaign />
  </v-sheet>
</template>
<script>
  import campaign from "./TenpoTokuten.vue";
  import SubTitle from "./SubTitle.vue";
  import LimitedVer from "./LimitedVer.vue";
  export default {
    components: {
      campaign,
      SubTitle,
      LimitedVer
    },
    data: () => ({
      sectionName: "商品情報",
      items: [
        {
          title: "タイトル",
          text: "BURAI MSX2 COMPLETE",
        },
        {
          title: "ハード",
          text: "Nintendo Switch",
        },
        {
          title: "ジャンル",
          text: "RPG",
        },
        {
          title: "CERO",
          text: "上巻 B <br/> 完結編 C",
        },
        {
          title: "発売日",
          text: "2026/2/19",
        },
        {
          title: "価格",
          text: "通常版　5,500円（税込）<br/>限定版　11,000円（税込）",
        },
      ],
    }),
  };
</script>
<style scoped>
  .listitem {
    text-align: center;
    margin: 0 auto;
  }
  .itemtitle {
    background: rgb(var(--v-theme-primary));
    font-weight: bold;
    padding: 0.5em 1em;
    line-height: 2em;
  }
  .wrap-text {
    white-space: normal;
    line-height: 1.2em;
  }
  
</style>
